const styles = (theme) => ({
    container: {
        padding: '20px',
        display: 'flex',
        flexDirection: 'row',
    },
    boxIcon: {
        margin: '10px',
        borderRadius: '50%',
        border: '2px solid #A10E75',
        background: '#940198',
        // eslint-disable-next-line no-dupe-keys
        background: '-moz-linear-gradient(45deg,  #940198 0%, #ff004d 100%)',
        // eslint-disable-next-line no-dupe-keys
        background: '-webkit-linear-gradient(45deg,  #940198 0%,#ff004d 100%)',
        // eslint-disable-next-line no-dupe-keys
        background: 'linear-gradient(45deg,  #940198 0%,#ff004d 100%)',
        filter: "progid:DXImageTransform.Microsoft.gradient( startColorstr='#940198', endColorstr='#ff004d',GradientType=1 )",
        width: '50px',
        height: '50px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
    },
    icon: {
        fontSize: '30px',
    },
    boxTitle: {
        maxWidth: '160px',
    },
    title: {
        textTransform: 'uppercase',
        margin: '10px 0 5px 0',
    },
    subtitle: {
        margin: '0',
        fontSize: '.9em',
    },
    boxButton: {
        padding: '10px',
        textAlign: 'center',
        borderTop: '2px solid #efefef',
    },
    button: {
        minWidth: '150px',
        backgroundColor: theme.palette.primary.button,
    },
    centerProgress: {
        textAlign: 'center',
    },
});

export default styles;
